import {Card,Form} from '@deere/ux.uxframe-react'
import React from 'react'
import {getAnswerLabel, getTranslation} from '../../utils/utils'

export default function FutureConsiderationReviewSection({sectionSurvey,answers}){

    if(!sectionSurvey)
        return <></>

    const questions = sectionSurvey.questions.sort((a, b) => (a.showOrder > b.showOrder)  ? 1 : -1)
    return (<div>        
                <Card>
                    <Card.Body>
                    <Card.Title className='pb-3'>
                        {getTranslation(sectionSurvey,'description')}
                    </Card.Title>
                    {questions?questions.map((q,idx) => <Form.Row key={idx}>
                        <Form.Group>
                            <Form.Label className="uxf-label">{getTranslation(q,'text')}</Form.Label>
                            <h6>{getAnswerLabel(q,answers)}</h6>
                        </Form.Group>
                    </Form.Row>):<></>}
                    
                    </Card.Body>
                </Card>
            </div>)
}   